import DescriptionInput from "Components/Common/Input/TextBoxes/DescriptionInput/DescriptionInput";
import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import Popover from "Components/Common/Popover/Popover";
import PopoverPane from "Components/Common/Popover/PopoverPane/PopoverPane";
import { ChecklistItemTemplate } from "Models/Checklists/ChecklistItemTemplate";
import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./ChecklistItemsPopover.scss";

interface IProps {
    items: ChecklistItemTemplate[];
    showItemsPopover: boolean;
    closePopover: () => void;
    onUpdate: (items: ChecklistItemTemplate[]) => void;
    addItem: () => void;
    popoverPaneIndex: number;
}

interface IState {
    items: ChecklistItemTemplate[];
    showItemsPopover: boolean;
    popoverPaneIndex: number;
    descriptionFileUrl?: string;
}

export class ChecklistItemsPopover extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            items: props.items,
            showItemsPopover: props.showItemsPopover,
            popoverPaneIndex: props.popoverPaneIndex
        };

        this.onMediaChanged = this.onMediaChanged.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (prevState.showItemsPopover !== nextProps.showItemsPopover
            || prevState.popoverPaneIndex !== nextProps.popoverPaneIndex) {
            partialState.showItemsPopover = !!nextProps.showItemsPopover;
            partialState.popoverPaneIndex = nextProps.popoverPaneIndex;
        }

        if (nextProps.items && nextProps.items !== prevState.items) {
            partialState.items = nextProps.items;
        }

        return partialState;
    }

    public onNameUpdated(itemIndex: number, newValue: string) {
        const items = [...this.state.items];
        items[itemIndex] = { ...items[itemIndex], name: newValue };
        this.setState({ items });
        this.props.onUpdate(items);
    }

    public onDescriptionUpdated(itemIndex: number, newValue: string) {
        const items = [...this.state.items];
        items[itemIndex] = { ...items[itemIndex], description: newValue };
        this.setState({ items });
        this.props.onUpdate(items);
    }

    public onMediaChanged(itemIndex: number, state: { imageFile?: File, videoFile?: File, videoThumbnailFile?: File }) {
        const items = [...this.state.items];
        items[itemIndex] = {
            ...items[itemIndex],
            pictureUrl: state.imageFile ? URL.createObjectURL(state.imageFile) : undefined,
            videoUrl: state.videoFile ? state.videoFile !== items[itemIndex].videoFile ? URL.createObjectURL(state.videoFile) : items[itemIndex].videoUrl : state.videoThumbnailFile ? items[itemIndex].videoUrl : undefined,
            videoThumbnailUrl: state.videoThumbnailFile ? URL.createObjectURL(state.videoThumbnailFile) : undefined,
            pictureFile: state.imageFile,
            videoFile: state.videoFile,
            videoThumbnailFile: state.videoThumbnailFile
        };
        this.setState({ items });
        this.props.onUpdate(items);
    }

    public deleteItem(itemNumber: number) {
        const localItems = this.state.items;
        localItems.splice(itemNumber - 1, 1);
        const paneIndex = localItems.length - 1;

        this.setState({
            items: localItems,
            showItemsPopover: true,
            popoverPaneIndex: paneIndex
        });

        this.props.onUpdate(localItems);
    }

    public render() {
        return (
            <Popover
                title={i18n.t("checklists.checklistItem")}
                isOpen={this.state.showItemsPopover}
                onClose={this.props.closePopover}
                paneIndex={this.state.popoverPaneIndex}
                addChild={this.props.addItem}
                deleteChild={this.deleteItem}
                addItemText={i18n.t("checklists.addChecklistItem")}
            >
                {
                    this.state.items.map((item, itemIndex) => (
                        <PopoverPane key={itemIndex}>
                            <MediaUpload
                                imageUrl={item.pictureUrl}
                                videoUrl={item.videoUrl}
                                videoThumbnailUrl={item.videoThumbnailUrl}
                                onChange={(state) => this.onMediaChanged(itemIndex, state)}
                            />
                            <TitleInput value={item.name} maxHeight={100} onChange={(newValue) => this.onNameUpdated(itemIndex, newValue)} placeholder={i18n.t("checklists.placeholders.checklistItemTitle")} />
                            <DescriptionInput value={item.description} maxHeight={100} onChange={(newValue) => this.onDescriptionUpdated(itemIndex, newValue)} placeholder={i18n.t("checklists.placeholders.checklistItemDescription")} />
                        </PopoverPane>
                    ))
                }
            </Popover>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistItems/ChecklistItemsPopover/ChecklistItemsPopover.tsx